import React from "react";
import IconDesigner from "../../icons/icon-designer.svg";

export const mainBannerObj = {
  classes: "career-details-banner",
  header: (<>Jr. Web Designer</>),
  content: "Full Time, Ahmedabad, India",
  icon: <IconDesigner />,
};

export const jobInfoObj = {
  title: "RAPIDOPS CAREERS",
  header: "About the Role",
  content: (<><p>Rapidops is looking for a Jr. Web Designer with 0.5 to 1.5 years of experience. They should also have a user interface design skills. You should be able to translate requirements into interaction flows and artifacts and transform them into beautiful, intuitive, and functional designs.</p></>),

  AboutWorktitle: "About the Work:",
  AboutWorkItems: [
    {
      content: "Proficiency with current design and editor tools – Sketch, Illustrator, Photoshop, DreamWeave & Atom"
    },
    {
      content: "Able to implement creative designs with HTML, CSS, SCSS, Bootstrap knowledge."
    },
    {
      content: "Work with managers & team leader to shape ideas and set the direction for the company."
    },
    {
      content: "Work with a multidisciplinary team including another designer, user researchers, developers, and product managers to deliver the best possible experience for our customers"
    },
    {
      content: "Ensure all designs work across all browsers and on all devices"
    },
    {
      content: "Should have good insight into the latest web standards, color combinations, fonts, etc used on the site."
    }
  ],

  AboutYoutitle: "About You:",
  AboutYouItems: [
    {
      content: "You’re based in Ahmedabad or plan to shift here in the nearby future."
    },
    {
      content: "You have at least 6 months of proven working experience as a Web Designer or similar"
    },
    {
      content: "You have good knowledge of HTML, CSS, and SCSS."
    },
    {
      content: "You have a basic knowledge of Javascript and to modify jQuery plugins"
    },
    {
      content: "You have a working knowledge of Bootstrap Frameworks and their components"
    },
    {
      content: "You have experience in designing responsive websites from the PSD or Sketch File"
    },
    {
      content: "Background in eCommerce would be a bonus"
    },
    {
      content: "You are really good at written and verbal English."
    },
    {
      content: "“That’s not my job” is not in your vocabulary."
    },
    {
      content: "Continually update skills by learning new technologies relevant to the role."
    },
    {
      content: "You believe in delivering back to the community and you do contributions toward it."
    },

  ],
};
